






























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Shared types
import { Accessory } from '@coldtec/cos-types';

/**
 *  Component that renders the accessory of an overview system,
 *  including the action to remove, his name and his price.
 */
@Component
export default class OverviewSystemAccessory extends Vue {

    @Prop({ type: Object, required: true })
    private accessory!: Accessory;

}
